export { default as checkForDeath } from "./checkForDeath";
